'use strict';

define(['valumsFileUploader', 'jquery'], function (qq, $) {

  if (document.getElementById('file-uploader')) {
    var $uploadService = $('#uploadService');
    var $authToken = $('#authToken');
    var $fileToken = $('#fileToken');
    var $fileUploader = $('#file-uploader');
    window.fileUploadJSON = {};

    var uploader = new qq.FileUploader({
      element: $fileUploader[0],
      multiple: false,
      inputName: '',
      action: $uploadService.attr('value'),
      customHeaders: {
        uploadToken: $authToken.attr('value')
      },
      sizeLimit: 1024 * 1024 * 4,
      onSubmit: function onSubmit() {},
      onProgress: function onProgress() {},
      onCancel: function onCancel() {},
      onUpload: function onUpload() {},
      onError: function onError() {},
      onComplete: function onComplete(id, fileName, responseJSON) {
        window.fileUploadJSON = responseJSON;
        if (responseJSON.successful) {
          $fileToken.val(responseJSON.token);
        }
      }
    });
    window.onload = uploader;
  }
});
//# sourceMappingURL=fileupload.js.map
